module.exports = __webpack_public_path__ + "static/media/ic_advance_pay_setup.3f60cc30.svg";